var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveDispatchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#727A82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79175 11.0417L6.83341 8L3.79175 4.95833L2.91675 5.83333L4.45841 7.375H0.666748V8.625H4.45841L2.91675 10.1667L3.79175 11.0417ZM9.62508 14.25H16.0834V1.75H9.62508V14.25ZM1.91675 15.5C1.58341 15.5 1.29175 15.375 1.04175 15.125C0.791748 14.875 0.666748 14.5833 0.666748 14.25V9.875H1.91675V14.25H8.37508V1.75H1.91675V6.125H0.666748V1.75C0.666748 1.41667 0.791748 1.125 1.04175 0.875C1.29175 0.625 1.58341 0.5 1.91675 0.5H16.0834C16.4167 0.5 16.7084 0.625 16.9584 0.875C17.2084 1.125 17.3334 1.41667 17.3334 1.75V14.25C17.3334 14.5833 17.2084 14.875 16.9584 15.125C16.7084 15.375 16.4167 15.5 16.0834 15.5H1.91675Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDispatchNormal);
export default __webpack_public_path__ + "static/media/liveDispatch-normal.d2a424a73831c8c0670346d596b7f581.svg";
export { ForwardRef as ReactComponent };